import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionFormDisplayComponent } from '../question-form-display/question-form-display.component';
import { Question } from 'src/app/models/question.model';
import { outputAst } from '@angular/compiler';

@Component({
    selector: 'que-collection-item',
    imports: [CommonModule, QuestionFormDisplayComponent],
    templateUrl: './collection-item.component.html',
    styleUrls: ['./collection-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionItemComponent {
  @Output() chooseQuestionEmit = new EventEmitter();
  @Input() question!: Question;
  addItemToBoard() {
    this.chooseQuestionEmit.emit();
  }
}
